import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AutoValorationActions } from './auto-valoration.action.types';
import { map, mergeMap } from 'rxjs';
import { ValorationService } from '@app/services/valoration.service';

@Injectable()
export class AutoValorationEffects {
  getPragmaPowersCategories$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AutoValorationActions.loadPragmaPowerCategories),
      mergeMap(r => {
        return this.valorationService
          .getPragmaPowerCategories(r.pragmaPowerRequest)
          .pipe(
            map(result =>
              AutoValorationActions.loadPragmaPowerCategoriesSuccess({
                pragmaPowerCategories: result,
              })
            )
          );
      })
    );
  });

  getPragmaPowersDefinition$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AutoValorationActions.loadPragmaPowerDefinition),
      mergeMap(r => {
        return this.valorationService
          .getPragmaPowerDefinition(r.pragmaPowerDefinitionRequest)
          .pipe(
            map(result =>
              AutoValorationActions.loadPragmaPowerDefinitionSuccess({
                pragmaPowerDefinition: result,
              })
            )
          );
      })
    );
  });

  getPragmaPowersBehaviorDefinition$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AutoValorationActions.loadPragmaPowersBehaviorsDefinition),
      mergeMap(r => {
        return this.valorationService
          .getPragmaPowerBehaviorDefinition(
            r.pragmaPowerBehaviorId,
            r.pragmaPowerBehaviorDefinitionRequest
          )
          .pipe(
            map(result =>
              AutoValorationActions.loadPragmaPowersBehaviorsDefinitionSuccess({
                pragmaPowerBehaviorDefinition: result,
              })
            )
          );
      })
    );
  });

  getSelfAssessmentPragmaPowersDefinition$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AutoValorationActions.loadSelfAssessmentPragmaPowerDefinitions),
      mergeMap(r => {
        return this.valorationService
          .getAssessmentPragmaPowers(
            r.idAssessment,
            r.assessmentPragmaPowerRequest
          )
          .pipe(
            map((assessmentPragmaPower) =>
              AutoValorationActions.loadSelfAssessmentPragmaPowerDefinitionsSuccess(
                {
                  assessmentPragmaPower,
                }
              )
            )
          );
      })
    );
  });

  constructor(
    private actions$: Actions,
    private valorationService: ValorationService
  ) {}
}
